import React, { useEffect, useState } from "react";

const ComplementryItems = ({ item, chooseVariety, selectedAttributeId, selectedModifierId }) => {

  return (
    <>
    {item?.modifier_options.length ? (
      <>
      {item?.modifier_options?.map((option) =>
        <div className={"col-md-6 col-lg-4 milk_item "+(selectedAttributeId == item.id && selectedModifierId == option.productModifierID ? 'active' : '')}>
          <div className="subText" 
          onClick={() =>
            chooseVariety(item.id, option.productModifierID)
          }
          >
              <div className="image">
                  <img src={item.default_image} alt={item.name}/>
              </div>
              <div className="text d-flex justify-content-between">
                  <h4>{item.name}</h4>
                  <div className="right">
                      <span className="dollar_value">+ 
                      ${((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                      <sup>{((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                      </span>                                                               
                  </div>
              </div>
              <p>{option.optionName}</p>
          </div>
      </div>
    )}
    </>
    ) : (
    <>
    <div className={"col-md-6 col-lg-4 milk_item "+(selectedAttributeId == item.id && selectedModifierId == 0 ? 'active' : '')}>
          <div className="subText" 
          onClick={() =>
            chooseVariety(item.id, 0)
          }
          >
              <div className="image">
                  <img src={item.default_image} alt={item.name}/>
              </div>
              <div className="text d-flex justify-content-between">
                  <h4>{item.name}</h4>
                  <div className="right">
                      <span className="dollar_value">+ 
                      ${((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                      <sup>{((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                      </span>                                                               
                  </div>
              </div>
          </div>
      </div>
    </>
    )}
  </>
  );
};

export default ComplementryItems;
